import { Grid } from "@mui/material"
import { useParams } from "react-router-dom"
import useGlobalStore from "../../stores/global"
import StatsBox, { StatsBoxType } from "../commons/StatsBox"

const InputFormStats = () => {
  const params = useParams()
  const asset = params?.denom ?? ''
  const userDataPerMarket = useGlobalStore((state) => state.userDataPerMarket)
  const userData = userDataPerMarket.find((market) => market.asset.toUpperCase() === asset.toUpperCase())
  if (!userData) {
    return null
  } //userData not found; TODO: add a not found page
  const formStatsPlaceHolder: StatsBoxType[] = [
    { title: `My ${asset} Deposited`, content: '0', subContent: '0', subContentType: 'dollar', type: 'number' },
    { title: `My ${asset} Borrowed`, content: '0', subContent: '0', subContentType: 'dollar', type: 'number' },
  ]

  const formStats: StatsBoxType[] = formStatsPlaceHolder.map((stats) => {
    switch (stats.title) {
      case `My ${asset} Deposited`:
        stats.content = userData.currentScaledTokenBalance
        stats.subContent = userData.currentScaledTokenBalance * userData.price
        break;
      case `My ${asset} Borrowed`:
        stats.content = userData.scaledVariableDebt
        stats.subContent = userData.scaledVariableDebt * userData.price
        break;
    }
    return { ...stats }
  })

  return (
    <Grid id='asset-stats' item container spacing={{ xs: 1, sm: 3 }} xs={12}>
      {
        formStats.map((stats) => {
          return <Grid item container width={'100%'} xs={6} sm={6} key={stats.title}>
            <StatsBox key={stats.title} {...stats} style={{ minWidth: '0rem' }} />
          </Grid>
        }
        )
      }
    </Grid>
  )
}

export default InputFormStats